// extracted by mini-css-extract-plugin
export var card = "subCategoryList-module--card--f0079";
export var div = "subCategoryList-module--div--1f22a";
export var header = "subCategoryList-module--header--1ae40";
export var text = "subCategoryList-module--text--3887e";